import { Colors } from 'app/utils/colors';

export const headerSortingStyle = {
  color: Colors.bbSecondary
};
